import React from 'react'
import { BetterComponent } from '../../../components/better-component/better-component'
import { AppState } from '../../../stores/app'
import { NotificationService } from '../../../services'
import { Container } from 'typescript-ioc/es5'
import './journey-revisions.scss'
import clone from 'clone'
import { StepType } from '@pushly/models/lib/enums/journeys'
import { Loading3QuartersOutlined } from '@ant-design/icons'
import { ApiVersion } from '../../../enums/api-version.enum'
import { JourneysBuilder } from 'src/features/journeys/journeys-builder'
import { JourneyBuilderMode } from '../enums/journey-builder-mode.enum'
import type { Journey, JourneyRevision } from '../types/journey-api-response'
import type { IJourneyStep } from '@pushly/models/lib/structs/journeys'

interface IJourneyWorkflowTabProps {
    journey: Journey
    activeTab: any
}

interface IJourneyWorkflowTabState {
    loading: boolean
    initialStateLoaded: boolean
    journey: Journey
    revision: JourneyRevision
}

export class JourneyWorkflowTab extends BetterComponent<IJourneyWorkflowTabProps, IJourneyWorkflowTabState> {
    protected static tabName = 'workflow'
    protected static tabLabel = 'Workflow'

    private appState: AppState
    private notifService: NotificationService

    public constructor(props: IJourneyWorkflowTabProps) {
        super(props)

        this.appState = Container.get(AppState)
        this.notifService = Container.get(NotificationService)

        this.state = {
            loading: true,
            initialStateLoaded: false,
            journey: this.props.journey,
            revision: this.props.journey.revision,
        }
    }

    public async componentDidMount() {
        const journey = clone(this.props.journey)
        if (this.props.journey) {
            const steps = await this.attachActionParams(journey.revision.steps)

            journey.steps = steps
            journey.revision.steps = steps

            return this.setState({ journey: journey, initialStateLoaded: true, loading: false })
        } else {
            return this.setState({ initialStateLoaded: true, loading: false })
        }
    }

    public render(): React.ReactNode {
        return (
            <div className="journey-workflow-tab">
                <div className="journey-workflow-tab-builder">
                    {!this.state.initialStateLoaded ? (
                        <Loading3QuartersOutlined
                            spin={this.isLoading}
                            style={{ fontSize: '24px', position: 'relative', top: '275px', left: '50%' }}
                        />
                    ) : (
                        <JourneysBuilder
                            key={this.props.activeTab ? `revision-${this.currentValue.id}` : 'hidden'}
                            loading={this.isLoading}
                            mode={JourneyBuilderMode.READONLY}
                            domain={this.appState.currentDomain!}
                            journey={this.state.journey}
                        />
                    )}
                </div>
            </div>
        )
    }

    public get isLoading() {
        return this.state.loading || !this.state.initialStateLoaded
    }

    public get currentValue() {
        return this.state.journey?.revision
    }

    protected attachActionParams = async (steps: IJourneyStep[]) => {
        let modifiedSteps = clone(steps)

        if (Array.isArray(modifiedSteps) && modifiedSteps.length > 0) {
            const resolvers = Promise.all(
                modifiedSteps.map(async (step) => {
                    const params = step.configuration?.params
                    const notificationId = params && 'notification_id' in params ? params.notification_id : undefined
                    if (!notificationId || step.type !== StepType.ACTION) {
                        return step
                    }

                    const query = {
                        include_schedules: false,
                    }
                    const notif = await this.notifService.fetchNotificationById(
                        this.appState.currentDomain!.id,
                        notificationId,
                        { query, version: ApiVersion.V4 },
                    )

                    if (notif) {
                        const params = step.configuration.params
                        if (params) {
                            params.notification = notif
                        }
                    }

                    return step
                }),
            )

            modifiedSteps = await resolvers
        }

        return modifiedSteps
    }
}
